import { del } from "idb-keyval";

import { getEnv } from "common/utilities";

/**
 * IndexedDB key the React Query persister writes the offline cache under.
 *
 * Shared rather than inlined in `index.jsx` because ending a session has to
 * delete it: the cache holds the previous user's workbooks, memberships and
 * profile, and leaving it behind means the next login paints their data before
 * the first request answers.
 */
export const getOfflineCacheKey = () => `populi:${getEnv()}:offline`;

export const clearOfflineCache = async () => {
  try {
    await del(getOfflineCacheKey());
  } catch (error) {
    // Signing out matters more than the cache being spotless.
    console.warn("Could not clear the offline query cache.", error);
  }
};
